// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryDetailSubCategoriesStyles } from "@rpsc/Overrides/Widgets/Category/CategoryDetailSubCategories";
import IconArrowLeftLink from "@rpsc/XDL/Icons/IconArrowLeftLink";
import IconMinus from "@rpsc/XDL/Icons/IconMinus";
import IconPlus from "@rpsc/XDL/Icons/IconPlus";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, createLinkIconStyles, sharedExpandButtonIconsStyles, styledScrollbar } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        gap: 12px;
        padding: 8px;
    `,
};

categoryDetailSubCategoriesStyles.titleContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        &:not(:empty) {
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 12px;
        }
    `,
};

categoryDetailSubCategoriesStyles.title = {
    size: fontConfig.fontSize.xSmall,
    lineHeight: fontConfig.lineHeight.xSmall,
    weight: fontConfig.weight.bold,
};

categoryDetailSubCategoriesStyles.parentLink = {
    mergeCss: true,
    ...createLinkIconStyles(IconArrowLeftLink, {
        typographyProps: {
            lineHeight: "14px",
        },
        icon: {
            position: "left",
            iconProps: {
                size: 12,
            },
        },
    }),
};

categoryDetailSubCategoriesStyles.links = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

categoryDetailSubCategoriesStyles.subTitle = {
    size: fontConfig.fontSize.xSmall,
    lineHeight: fontConfig.lineHeight.xSmall,
    weight: fontConfig.weight.bold,
};

categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    mergeCss: true,
    typographyProps: {
        css: css`
            line-height: 17px;
        `,
    },
    css: css`
        &:not(:last-child) {
            margin-bottom: 4px;
        }
    `,
};

categoryDetailSubCategoriesStyles.card = {
    cardContainer: {
        css: css`
            width: 134px;
        `,
    },
    categoryImage: {
        css: css`
            width: 134px;
            height: 134px;
        `,
    },
    categoryNameLink: {
        mergeCss: true,
        css: css`
            &&& span {
                font-size: ${fontConfig.fontSize.xSmall};
                line-height: ${fontConfig.lineHeight.xxSmall};
            }
        `,
    },
};

categoryDetailSubCategoriesStyles.scrollableContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-height: 254px;
        overflow-x: hidden;
        padding-right: 14px;
        width: 100%;
        ${styledScrollbar({ width: 4 })}
    `,
};

categoryDetailSubCategoriesStyles.seeMoreLink = {
    ...createLinkIconStyles(IconPlus, {
        ...sharedExpandButtonIconsStyles,
    }),
};

categoryDetailSubCategoriesStyles.seeLessLink = {
    ...createLinkIconStyles(IconMinus, {
        ...sharedExpandButtonIconsStyles,
    }),
};
